var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1251 44.535H6.23517C3.20517 44.535 0.745117 42.075 0.745117 39.045V6.15504C0.745117 3.12504 3.20517 0.665039 6.23517 0.665039H39.1251C42.1551 0.665039 44.6152 3.12504 44.6152 6.15504V21.095H40.8452V6.15504C40.8452 5.20504 40.0751 4.43504 39.1251 4.43504H6.23517C5.28517 4.43504 4.51514 5.20504 4.51514 6.15504V39.045C4.51514 39.995 5.28517 40.765 6.23517 40.765H19.1251V44.535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7452 11.2051H2.63525V14.9751H42.7452V11.2051Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2749 48.3155C28.1149 48.3155 22.2949 42.4955 22.2949 35.3355C22.2949 28.1755 28.1149 22.3555 35.2749 22.3555C42.4349 22.3555 48.2549 28.1755 48.2549 35.3355C48.2549 42.4955 42.4349 48.3155 35.2749 48.3155ZM35.2749 26.1255C30.1949 26.1255 26.0649 30.2555 26.0649 35.3355C26.0649 40.4155 30.1949 44.5455 35.2749 44.5455C40.3549 44.5455 44.4849 40.4155 44.4849 35.3355C44.4849 30.2555 40.3549 26.1255 35.2749 26.1255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.725 41.9348L28.895 37.8248L31.335 34.9548L33.395 36.7048L39.155 30.4248L41.935 32.9748L33.725 41.9348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.cf6b295a01bc2099a5ea3444ec05b315.svg";
export { ForwardRef as ReactComponent };